import React, { useContext, useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getAuthorizedModules, SelectedModuleContext } from '../../../../constants/acl-config';
import { useUserPolicy } from '../../../../user-policy';

const ModulesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
`;

const Module = styled.div`
  cursor: pointer;
  width: 100%;
  height: 60px;
  font-size: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 10px solid transparent;

  ${({ selected, theme }) =>
    selected &&
    `
    border-left: 10px solid ${theme['@primary-color']};
    color: ${theme['@primary-color']};
  `}

  &:hover {
    color: ${({ theme }) => theme['@primary-color']};
  }
`;

function AuthorizedModules() {
  const { selectedModule, setSelectedModule } = useContext(SelectedModuleContext);

  const location = useLocation();
  const { userAccount } = useUserPolicy();
  const allowedModules = getAuthorizedModules(userAccount.ability);

  useEffect(() => {
    const foundModuleByLocation = allowedModules.find(({ routes }) =>
      routes.find(({ path }) => matchPath(path, location.pathname))
    );
    if (foundModuleByLocation) {
      setSelectedModule(foundModuleByLocation);
    }
  }, [location]);

  return (
    <ModulesWrapper>
      {allowedModules.map((module) => (
        <Module
          title={module.name}
          selected={selectedModule && selectedModule.key === module.key}
          onClick={() => setSelectedModule(module)}
        >
          {module.icon}
        </Module>
      ))}
    </ModulesWrapper>
  );
}

AuthorizedModules.propTypes = {};

export default AuthorizedModules;
